"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1861],{

/***/ 81861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58598);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var NltMoreInfoMobile = function NltMoreInfoMobile(_ref) {
  var image = _ref.image,
      itemsTitle = _ref.itemsTitle,
      items = _ref.items,
      description = _ref.description,
      descriptionTitle = _ref.descriptionTitle,
      actionText = _ref.actionText,
      actionTitle = _ref.actionTitle;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .VStack */ .gC, {
    spacing: -130,
    align: "stretch",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      bg: "primaryGreen.800",
      p: "l",
      pb: "8rem",
      pos: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .H2Title */ .kY, {
        mr: "5",
        mb: "7",
        fontSize: "1.5rem",
        lineHeight: "1.938rem",
        children: descriptionTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "1rem",
        lineHeight: "1.425rem",
        textAlign: "left",
        color: "baseWhite",
        mt: ".75rem",
        children: description
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      p: "l",
      zIndex: "2",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: image,
        alt: itemsTitle,
        width: "364",
        height: "252",
        objectFit: "contain",
        loading: "lazy",
        decoding: "async",
        className: "rounded"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      bg: "baseWhite",
      p: "l",
      pt: "8rem",
      textAlign: "left",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .H2Title */ .kY, {
        color: "baseDark",
        fontSize: "1.125rem",
        lineHeight: "1.463rem",
        children: itemsTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .ListWithIcons */ .S$, {
        items: items,
        color: "baseDark",
        fontSize: "0.875rem"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .TextLink */ .hh, {
        href: "/noleggio-a-lungo-termine/faq",
        title: actionTitle,
        color: "baseDark",
        children: [actionText, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowForwardIcon */ .mr, {})]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NltMoreInfoMobile);

/***/ })

}]);